var Forms = {

	elements: {
		input_container: $('.input-container'),
		input_content_container: $('.input-content-container'),
		input_elements: $('.input-elements'),
		arrow_down: $('.arrow-down-btn'),
		close_btn: $('.close-btn'),
		add_btn: $('.add-btn'),
		plus_btn: $('.plus-btn'),
		minus_btn: $('.minus-btn'),
		input_quantity: $('.input-quantity'),
		input_qty_form:('.input-qty-form')
	},

	init: function() {
		Forms.toggleInputContainer();
		Forms.increaseDecrease();
		Forms.tabsFunc();
		Forms.selectRadio();
		Forms.deleteRercord();
	},

	toggleInputContainer: function() {
		var item = Forms.elements;

		item.input_elements.on('click', function(e){
			e.preventDefault();

			$(this).next(item.input_content_container).toggleClass('opened');
			$(this).parent().find(item.arrow_down).toggle();
		});

		item.close_btn.on('click', function(e){
			e.preventDefault();

			$(this).closest(item.input_content_container).find('.selected').removeClass('selected');
			$(this).closest(item.input_content_container).find('input:radio').each(function () {
				if($(this).prop('checked') == true) {
					$(this).prop('checked',false);
				}
			});
			$(this).closest(item.input_content_container).toggleClass('opened');
			$(this).closest(item.input_content_container).next().next().toggle();
		});

		item.add_btn.on('click', function(e){
			e.preventDefault();

			$(this).closest(item.input_content_container).toggleClass('opened');
			$(this).closest(item.input_container).toggleClass('checked');
		});
	},

	increaseDecrease: function() {
		var item = Forms.elements;

		item.plus_btn.on('click',function(e){
			var input_val = $(this).closest(item.input_qty_form).find(item.input_quantity).val();

			e.preventDefault();
			$(this).closest(item.input_qty_form).find(item.input_quantity).val(parseInt(input_val)+1);
		});

		item.minus_btn.on('click',function(e){
			var input_val = $(this).closest(item.input_qty_form).find(item.input_quantity).val();
			
			e.preventDefault();
			if( input_val > 1 ) {
				$(this).closest(item.input_qty_form).find(item.input_quantity).val(parseInt(input_val)-1);
			}
		});
	},

	tabsFunc: function() {
		$('[data-show]').on('click', function() {
	        var openTab = $(this).attr('data-show');
	        $('[data-view]').removeClass('active');
	        $('[data-view="' + openTab + '"]').addClass('active');

	        $('.tab-buttons').find('li').removeClass('active');
	        $(this).parent().addClass('active');
	    });
	},

	selectRadio: function() {
		$('.radio').click(function() {
			var radioId =  $(this).attr('for');
			var radio = $('#' + radioId);
			var radioName = radio.attr('name');
			var parent = radio.parents('.two-cols-container');
			
			$( "input[name*='"+ radioName +"']" ).prop('checked',false);
			$('.selected').removeClass('selected');

			if(radio.is('checked') == false) {
				radio.prop('checked',true);
				parent.addClass('selected');
			}
			else {
				radio.prop('checked',false);
			}
		});
	},

	deleteRercord: function() {
		$('.sc-delete').click(function(e){
			e.preventDefault();
			$(this).parents('.sc-unit').remove();

			//Remove cart after all Items removed
			if($('ul.shopping-cart-wrapper').find('.sc-unit').length == 0){
				$('div.your-cart').css('display','none');
				$('div.cart-empty').css('display','block');
			}
			else{
				$('div.cart-empty').css('display','none');
				$('div.your-cart').css('display','block');
			}
		});
	}

};